'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (prop) {
  if (prop.indexOf('data-') === 0) return true;
  if (prop.indexOf('aria-') === 0) return true;

  return false;
};